import React, { useEffect, useState } from "react";
import { Card, Tabs } from "antd";
import ContactUsTable from './ContactUsTable';
import moment from 'moment-jalaali';
import { useGeneralStore } from "../../store/slices/createGeneralSlice";

const { TabPane } = Tabs;

export default function Tickets() {
    const general = useGeneralStore();
    const [currentKey, setCurrentKey] = useState(1);
    const today = new Date();
    const lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);

    useEffect(() => {
        callback(currentKey);
    }, []);

    function callback(key) {
        switch (key) {
            case "2":
                general.getTickets({
                    id: 2,
                    isTicket: false,
                    fromDate: (moment(lastWeek).format('YYYY/MM/DD')).replaceAll('/', '-'),
                    toDate: (moment(new Date()).format('YYYY/MM/DD')).replaceAll('/', '-'),
                });
                break;
            default:
                general.getTickets({ id: 0, isTicket: false, fromDate: null, toDate: null });
        }

    }

    return (
        <Card>
            <Tabs defaultActiveKey="1" onChange={callback} centered onTabClick={(key => setCurrentKey(key))}>
                <TabPane tab="تیکت‌های باز" key="1" >
                    <ContactUsTable filter={false} />
                </TabPane>
                <TabPane tab="تیکت‌های بسته" key="2" >
                    <ContactUsTable filter={true} />
                </TabPane>
            </Tabs>
        </Card>
    );
}
